import type { ReactNode } from "react"
import { Input, Popover, Select } from "antd"
import styles from "@/styles/view-cart.module.scss"

interface ShippingEstimatorProps {
  postCode: number | string
  suburb: string
  suburbList: any[]
  helpText: ReactNode
  onPostCodeChange: (event: any) => void
  onSuburbSelect: (value: any) => void
}

const ShippingEstimator = ({
  postCode,
  suburb,
  suburbList,
  helpText,
  onPostCodeChange,
  onSuburbSelect
}: ShippingEstimatorProps) => (
  <div className={styles['postcode-box']}>
    <div className={styles['postcodeTitle']}>
      This quotation is based on postcode <span style={{ width: '32px', display: 'inline-block' }}>{postCode}</span>. <Popover placement="bottom" content={helpText}><span className={styles['help-span']}>Help?</span></Popover> PostCode:
    </div>
    <Input value={postCode} onChange={onPostCodeChange} maxLength={4} className={styles["post-input"]} width={80} />
    <Select className={styles["code-select"]} value={suburb} onSelect={onSuburbSelect} options={suburbList} fieldNames={{ label: "subName", value: "subID" }} />
  </div>
)

export default ShippingEstimator
